import Vue from 'vue'
import App from './App.vue'
import { resizeScale } from '@/utils/resize'

Vue.config.productionTip = false


new Vue({
  render: h => h(App),
}).$mount('#app')

// resizeScale();
